import classNames from 'classnames';

import { NOOP } from '@lootboy/lib/utils';

import ButtonClean from '~/components/ButtonClean';

import { TCollectionRankingEntryProps } from '~/views/CollectionView/CollectionRanking/CollectionRankingEntry';
import { RankingEntryAvatar } from '~/views/CollectionView/CollectionRanking/CollectionRankingEntry/RankingEntryAvatar';
import RankingMedalIcon from '~/views/CollectionView/CollectionRanking/CollectionRankingEntry/RankingMedalIcon';

import styles from './CollectionRankingMedalEntry.module.scss';

type TCollectionRankingMedalEntryProps = Omit<
  TCollectionRankingEntryProps,
  'showRadarIcon' | 'onPositionIconClick'
>;

export function CollectionRankingMedalEntry({
  rankingEntry,
  onClick,
}: TCollectionRankingMedalEntryProps): JSX.Element {
  return (
    <ButtonClean
      className={classNames(
        styles.medalEntryContainer,
        rankingEntry.isUserEntry && styles.userRanking,
        !onClick && styles.notClickable,
      )}
      onClick={onClick ?? NOOP}
    >
      <div className={styles.positionContainer}>
        <div className={styles.position}>{rankingEntry.no}</div>
        <RankingMedalIcon
          place={rankingEntry.no}
          className={styles.medalIcon}
        />
      </div>
      <RankingEntryAvatar
        avatarUrl={rankingEntry.avatar ?? ''}
        alt={`${rankingEntry.username} avatar`}
        showRadarIcon={rankingEntry.isUserEntry && !rankingEntry.avatar}
        className={classNames(
          styles.imageContainer,
          rankingEntry.no === 1 && styles.gold,
          rankingEntry.no === 2 && styles.silver,
          rankingEntry.no === 3 && styles.bronze,
        )}
      />
      <p className={styles.username}>{rankingEntry.username}</p>
      <div className={styles.value}>{rankingEntry.value}</div>
    </ButtonClean>
  );
}
